import { createContext, useContext } from "react";

import { Post } from "@/api/areas/types";

export type ModuleDetailContextType = {
  post: Post;
};

export const ModuleDetailContext =
  createContext<ModuleDetailContextType | null>(null);

export const useModuleDetailContext = () => {
  const ctx = useContext(ModuleDetailContext);
  if (!ctx)
    throw new Error(
      "useModuleDetailContext must be used within ModuleDetailContext"
    );
  return ctx;
};
